import React, { useRef, useCallback, useState, Suspense } from "react"
import AppBar from "../../components/AppBar/AppBar"
import Backdrop from "../../components/Backdrop/Backdrop";
import ControlPanelView from "views/ControlPanelView"
import { formatNumber } from "chart.js/helpers"
import { selectDatePicker } from "reducers/datePickerSlice"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";


export const BoardContext = React.createContext({
    boardRef: null,
    regions: null,
    buildingCode: null,
    systemCode: null,
    postCode: null,
    dateType: null,
    startDate: null,
    endDate: null
})

const BoardLayout = ({children, drawer}) => {

    const boardRef = useRef()
    const {buildingCode, systemCode, postCode} = useParams()
    const {filter, from, to} = useSelector(selectDatePicker)
    const {regionsActive} = useSelector(state => ({
        regionsActive: state.regions.actives
    }))

    const [open, setOpen] = useState(false)
    const hasDrawer = drawer !== null

    const renderDrawer = useCallback(() => {
        if(hasDrawer){
            return (
                <div className="drawer">
                    <Suspense fallback={<LoadingScreen/>}>
                        {drawer}
                    </Suspense>
                </div>
            )
        }else{
            return null
        }
    })

    const onAppBarToggle = () => {
        setOpen(prevOpen => !prevOpen)
    }

    const menuOpen = open ? 'menu-open': ''


    return (
        <div ref={boardRef} className={`board ${menuOpen}`} >
            <BoardContext.Provider value={{
                boardRef: boardRef.current,
                regions: regionsActive,
                buildingCode: buildingCode,
                systemCode: systemCode,
                postCode: postCode,
                dateType: filter,
                startDate: from,
                endDate: to
            }}>
                {renderDrawer()}
                <div className="content">
                    <AppBar 
                        hasDrawer={hasDrawer} 
                        onAppBarToggle={onAppBarToggle} 
                    />
                    <Backdrop/>
                    {children}
                </div>
            </BoardContext.Provider>
        </div>
        
    )
}

BoardLayout.defaultProps = {
    children: null,
    drawer: null
}

export default BoardLayout